/* eslint-disable */
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// @ts-ignore
import enLanguage from "./i18n/en.json";
// @ts-ignore
import csLanguage from "./i18n/cs.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: enLanguage,
    },
    cs: {
        translation: csLanguage,
    },
};

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: "en",
        returnNull: false,
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        //debug: true,
    });

export default i18n;
